













import TitleBar from '@/modules/core/components/TitleBar.vue';
import Tiles from '@/modules/core/components/Tiles.vue';
import CardWidget from '@/modules/core/components/CardWidget.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import AgencyEdit from '../components/AgencyEdit.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TitleBar,
    Tiles,
    CardWidget,
    CardComponent,
    AgencyEdit,
  },
})
export default class AgencyEditView extends Vue {
  public agency = {};

  public get titleStack(): string[] {
    return ['Admin', this.agencyId ? 'Edition d\'agence' : 'Nouvelle agence'];
  }
  public get agencyId(): string {
    return this.$router.currentRoute.params.id;
  }

  public goBack(): void {
    this.$router.go(-1);
  }

  public async agencyEdited(): Promise<void> {
    this.goBack();
  }
}
